import './App.css'
import { FC } from 'react'

import { Router } from 'src/Router'

const App: FC = () => {
  return <Router />
}

export default App
